<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <div class="md-layout-item md-size-20 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>receipt_long</md-icon>엑셀 업로드
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="flex-div">
              <h5 class="title">엑셀 업로드</h5>
              <div class="inline-flex">
                <input type="file" class="hidden-input-file" id="bundleFileInput" accept=".xlsx"/>
                <input type="text" v-model="excelFileName" disabled />
                <button v-focus @click="onClickSearchExcel">
                  <md-icon>search</md-icon>엑셀 파일 찾기
                </button>
              </div>
            </div>
          </md-card-content>
          <md-card-actions>
            <md-button class="md-success md-sm full-size-button" @click="uploadExcelFile" :disabled="!excelFile">
              <md-icon>publish</md-icon>엑셀 업로드
            </md-button>
          </md-card-actions>
        </md-card>
      </div>
      <div class="md-layout-item md-size-80 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>assignment</md-icon>업로드 조회 결과
            </h4>
          </md-card-header>
          <md-card-content>
            <div class="table-header-info">
              <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
              <md-card-actions md-alignment="right">
                <md-button class="md-info md-sm" :disabled="selectedRows.length === 0" @click="bundleUpdate">
                  <md-icon>check</md-icon>일괄 처리
                </md-button>
              </md-card-actions>
            </div>
            <md-table :value="tableData" class="paginated-table table-striped table-hover text-align-center h-scroll h610" @update:mdSelectedValue="selectRow">
              <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="multiple" md-auto-select>
                <md-table-cell md-label="이체일">{{ item.feeDate }}</md-table-cell>
                <md-table-cell md-label="고객조회번호">{{ item.feeId }}</md-table-cell>
                <md-table-cell md-label="교우번호">{{ item.memberNo }}</md-table-cell>
                <md-table-cell md-label="금액">{{ formatter.getCurrency(item.feeAmt) }}</md-table-cell>
                <md-table-cell md-label="수납일">{{ item.feeRecvdate }}</md-table-cell>
                <md-table-cell md-label="입금구분">{{item.feeCd}}</md-table-cell>
                <md-table-cell md-label="회비년도">{{item.feeYear}}</md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import parser from "@/kuaa/kuaa-parser";

import Swal from "sweetalert2";


export default {

  data() {
    return {
      formatter,
      excelFile: null,
      excelFileName: null,
      // checkbox 로 선택된 항목들
      selectedRows: [],
      total: 0,
      tableData: [],
      failCnt: 0
    };
  },
  methods: {
    onClickSearchExcel(e) {
      let input = document.getElementById("bundleFileInput");
      input.onchange = e => {
        let file = e.target.files[0];
        this.excelFileName = file.name;
        this.excelFile = file;
      };

      input.click();
    },
    uploadExcelFile(e) {

      let xls = this.excelFile;
      parser.parseXlsFeeOCRData(xls, (res)=>{
		  this.tableData = res;
        this.total = this.tableData.length;
      });
    },

    resetView(){
      this.tableData = [];
      this.total = 0;
      this.excelFile = null;
      this.excelFileName = null;
      this.failCnt = 0;
    },

    selectRow(rowList) {
      this.selectedRows = rowList;
    },

    bundleUpdate(e) {
      let _this = this;

      let cnt = this.selectedRows.length;
      if(cnt == 0){
        Swal.fire(kuaaFnc.getSwalModaloptions({html:`처리할 데이타를 선택해 주세요.`}));
        return false;
      }

      Swal.fire(kuaaFnc.getSwalModaloptions('confirm', {
        html: "요청을 처리하시겠습니까?",
      })).then(result => {

        if (result.value) {
          let failCnt = 0;
          let failData = [];
          let isStop = false;
          this.selectedRows.forEach((row,idx) => {
                if (row.feeYear.substring(0, 2) != 20) {
                  kuaaFnc.showSwal("OCR 파일처리", row.memberNo + '의 데이터 형식이 잘못되었습니다.');
                  return false;
                }
                row.orgFeeCd = "";
              }
          );
          if(isStop)  return false;

          kuaaApi.sendServer(
              URL_CONST.SAVE_FEE_OCR_LIST,
              this.selectedRows,
              "post",
              response => {
                if (response.data.success) {

                  //알림톡 발송
                  if (e) {
                    e.stopPropagation();
                    e.preventDefault();
                  }

                  _this.sendKakaoTalk(response.data.data).then(function () {
                    setTimeout(() => {
                      _this.resetView();
                      Swal.fire(kuaaFnc.getSwalModaloptions({html: response.data.data.length + ' 건의 데이터가 일괄 처리 되었습니다.'}));
                    }, 1000);

                  }).catch(error => {
                  });

                } else {
                  Swal.fire(kuaaFnc.getSwalModaloptions({html: '일괄 처리에 실패하였습니다'}));
                }
              }
          );
        }
      });
    },

    async sendKakaoTalk(paramList){
      let dstArr = [];
      paramList.forEach((data)=>{
        dstArr.push({
          Company: "고려대학교교우회",
          Name: data.memberHnm,
          Phone: data.cellular,
          Replace_Datas: [{Key:"#{이름}",Value:data.memberHnm},{Key:"#{기타1}",Value: formatter.getDateFormat(data.feeDate)},{Key:"#{기타2}",Value:data.feeCdNm},{Key:"#{기타3}",Value:formatter.getCurrency(data.feeAmt)+'원'}]
        })
      });

      try {
        let apiparams = {
          UserID : "kuaa1905",
          UserPW : "kou1905!",
          Service : "ATALK",
          Type : "Send",
          Fail_To : "LMS",
          Subject : "회비납부안내",
          Template_Seq : "4765",
          Callback : "15881905",
          Fail_To_Template : "1",
          //Main_Text : "LMS로 전환됩니다.",
          Destination : JSON.stringify(dstArr)
        }

        return await kuaaApi.sendServer2(
            "https://balsong.com/Linkage/API/",
            apiparams,
            "post"
        );

      }catch{
        //console.log("======= exception ========");
        // return false시 trnsaction 미발생
        return true;
      }
    }
  }
};
</script>


<style scoped></style>
